module.exports = __webpack_public_path__ + "img/user.1ff61334.png";